<template>
  <b-container>
    <b-row align-h="center" class="m-5">
      <h1 class="display-3">Donate</h1>
    </b-row>

    <b-row align-h="center">
        <plan v-for="plan in plans" v-bind:key="plan.plan_id" v-bind:plan="plan">
        </plan>
    </b-row>
  </b-container>
</template>

<script>

// APIs
import PlanApi from "@/services/PlanApi";

// Components
import Plan from './Components/Plan.vue'

export default {

  components: {
    Plan
  },

  async created() {
    try {
      this.plans = await PlanApi.getPlans();
    } catch (err) {
      this.error = err.message;
    }
  },
  data() {
    return {
      plans: [],
    };
  },
  methods: {}
};
</script>

<style lang="scss" rel='stylesheet/scss' src="./style.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Index/Index.vue